export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type Organization = {
  __typename?: 'Organization';
  created: Maybe<Scalars['Int']['output']>;
  flags: Maybe<OrganizationMemberFlags>;
  horizontalLogo: Maybe<Scalars['ID']['output']>;
  isPremiumLab: Maybe<Scalars['Boolean']['output']>;
  isSolo: Maybe<Scalars['Boolean']['output']>;
  isVatPayer: Maybe<Scalars['Boolean']['output']>;
  isZalamoMarketDigitalCreator: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  roles: Maybe<Array<Maybe<PermissionRole>>>;
  squareLogo: Maybe<Scalars['ID']['output']>;
  zalamoPayConfigFinished: Maybe<Scalars['Boolean']['output']>;
  zalamoPayRegisterInProgress: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationMemberFlags = {
  __typename?: 'OrganizationMemberFlags';
  hideOrders: Maybe<Scalars['Boolean']['output']>;
  hideRevenue: Maybe<Scalars['Boolean']['output']>;
};

export enum OrganizationResource {
  AlbumDesign = 'AlbumDesign',
  DigitalOrder = 'DigitalOrder',
  MemberManagement = 'MemberManagement',
  Orders = 'Orders',
  OrganizationDetails = 'OrganizationDetails',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  Products = 'Products',
  PublicSession = 'PublicSession',
  PublicSessions = 'PublicSessions',
  Wedding = 'Wedding',
  ZalamoRevenueReports = 'ZalamoRevenueReports',
}

export enum Permission {
  Insert = 'Insert',
  Read = 'Read',
  ShowPrices = 'ShowPrices',
  Update = 'Update',
}

export enum PermissionRole {
  Admin = 'Admin',
  CampaignManager = 'CampaignManager',
  LabEmployee = 'LabEmployee',
  LabManager = 'LabManager',
  LabOutsource = 'LabOutsource',
  OrdersManager = 'OrdersManager',
  Photographer = 'Photographer',
  RetouchManager = 'RetouchManager',
  Retoucher = 'Retoucher',
  Support = 'Support',
}

export type Query = {
  __typename?: 'Query';
  allPermissions: Maybe<Array<Maybe<Permission>>>;
  mineOrganizations: Maybe<Array<Maybe<Organization>>>;
};
